"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbHybridSession = void 0;
/* eslint-disable complexity */
const framework_1 = require("../../../framework");
const events_1 = require("../../../features/events");
class MbHybridSession extends framework_1.BaseSession {
    constructor(sessionStorage, refreshToken, eventBus) {
        super(sessionStorage);
        this.doRefresh = () => __awaiter(this, void 0, void 0, function* () {
            try {
                (0, events_1.publishRefreshingSessionEvent)(undefined, this.eventBus);
                const accessToken = yield this.refreshToken();
                (0, events_1.publishRefreshedSessionEvent)({ accessToken }, this.eventBus);
                return Promise.resolve({ accessToken });
            }
            catch (e) {
                this.finishSession();
                (0, events_1.publishErrorRefreshingSessionEvent)(e, this.eventBus);
                throw e;
            }
        });
        this.isDataValid = (sessionData) => {
            if (sessionData.accessToken) {
                return true;
            }
            return false;
        };
        this.refreshToken = refreshToken;
        this.eventBus = eventBus;
    }
    onRefreshToken(callback) {
        return (0, events_1.subscribeRefreshedSessionEvent)(callback, this.eventBus);
    }
    onRefreshTokenError(callback) {
        return (0, events_1.subscribeErrorRefreshingSessionEvent)(callback, this.eventBus);
    }
    onRefreshingToken(callback) {
        return (0, events_1.subscribeRefreshingSessionEvent)(callback, this.eventBus);
    }
}
exports.MbHybridSession = MbHybridSession;
//# sourceMappingURL=index.js.map